<template lang="pug">
.v-vacancies-page.vacancies-page(v-if="data")
	.vacancies-page.page-head(v-if="data.title")
		component.page-head__title(
			:is="data.titleLevel ? data.titleLevel : 'h1'"
			:class="data.titleStyleLevel")
			| {{data.title}}
	.vacancies-page__body
		.vacancies-page__description(v-if="data.description")
			.vacancies-page__description-text(v-if="data.description.text" v-html="data.description.text")
			//.vacancies-page__description-wrap
			//	.vacancies-page__description-left(v-if="data.description.left")
			//		h3.vacancies-page__description-title(
			//				v-if="data.description.left.title")
			//			| {{ data.description.left.title }}
			//		.vacancies-page__description-text(
			//			v-if="data.description.left.text"
			//			v-html="data.description.left.text" )
			//	.vacancies-page__description-right(v-if="data.description.right")
			//		.vacancies-page__description-title(
			//			v-if="data.description.right.title")
			//			| {{ data.description.right.title }}
			//		.vacancies-page__description-text(
			//			v-if="data.description.right.text"
			//			v-html="data.description.right.text" )
			img.vacancies-page__description-image(
				v-if="data.image"
				:src="data.image?.src"
				:alt="data.image?.alt")
		.vacancies-page__wrap
			.vacancies-page__items(v-if="data.items" )
				template(v-for="(card, index) in data.items" :key="index")
					v-vacancy-card.vacancies-page__item.flc(
						@openForm="showForm"
						:data-source="card")

	.vacancies-page__aside-modal
		transition(name="show-aside")
			.aside-modal(v-if="asideOpen ")
				.aside-modal__overlay(@click.stop="closeForm")
				.aside-modal__inner.scrollbar
					.aside-modal__body
						button.aside-modal__close(@click.stop="closeForm")
							v-svg-icon.aside-modal__close-icon(icon="cross")
						template(v-if="$slots['feedback-form']")
							slot(name="feedback-form" :vacanciesId="vacanciesId")


</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import scrollLock from "scroll-lock";

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null,
			asideOpen: false,
			vacanciesId: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;

			// if(this.data.tabs && this.data.tabs.length) {
			// 	this.activeTabId = this.data.tabs.find(tab => tab.active).tabId
			// }
		},

		// setActiveTab(tabId) {
		// 	this.activeTabId = tabId
		// },

		showForm(id) {
			this.asideOpen = true;
			this.vacanciesId = id;
			scrollLock.enablePageScroll();
			scrollLock.disablePageScroll(document.querySelectorAll('.aside-modal__inner'));
		},

		closeForm() {
			this.asideOpen = false;
			scrollLock.enablePageScroll(document.querySelectorAll('.aside-modal__inner'));
		},
	},

}

</script>